import QueryRow from "./QueryRow";
import Table from "../../ui/Table";
import Menus from "../../ui/Menus";
import { useGetUserQueries } from "./useGetUserQueries";

import Pagination from "../../ui/Pagination";

function QueryTable() {
  const { data, isLoading } = useGetUserQueries();
  let queries = data;
  if (isLoading) queries = Array.from(Array(5).keys());
  return (
    <Menus>
      <Table columns="3.0fr 1.0fr 1.0fr 0.5fr 1.0fr">
        <Table.Header>
          <div>Scheduled Searches</div>
          <div>Notice type</div>
          <div>Frequency</div>
          {/* <div>Filters</div> */}
          <div>Active</div>
          <div>Delete</div>
        </Table.Header>
        <Table.Body
          data={queries}
          render={(query) => (
            <QueryRow
              key={query.table_id}
              query={query}
              isLoading={isLoading}
            />
          )
        }
        emptyMessage="Schedule your first search query."
        />
        {!isLoading && (
          <Table.Footer>
            <Pagination count={queries.length} />
          </Table.Footer>
        )}
      </Table>
    </Menus>
  );
}

export default QueryTable;
